import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import OmManpower from "@/pages/OmManpower";
import Industries from "@/pages/Industries";
import WhyEvovlex from "@/pages/WhyEvovlex";
import Contact from "@/pages/Contact";

let lenis = null;

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <section className="flex min-h-[70vh] flex-col items-center justify-center bg-navy-950 px-6 pt-20 text-center">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400">404</p>
    <h1 className="mt-4 font-display text-4xl font-bold text-white">Page not found</h1>
    <a
      href="/"
      data-testid="not-found-home-link"
      className="mt-8 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 px-6 py-3 text-sm font-semibold text-white"
    >
      Back to Home
    </a>
  </section>
);

function App() {
  useEffect(() => {
    lenis = new Lenis({ lerp: 0.08, duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/om-manpower-services" element={<OmManpower />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/why-evovlex" element={<WhyEvovlex />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
